module.exports = __webpack_public_path__ + "media/payment/paid-0f964b6f.svg";